import React from 'react';

export const DeviceDistributionChart = React.memo(({ deviceStats }) => {
  return (
    <div className="chart-card" style={{
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      height: '425px'
    }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, textAlign: 'center' }}>
        Device Distribution
      </h3>
      <div style={{ height: '220px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{
          width: '210px',
          height: '210px',
          borderRadius: '50%',
          background: `conic-gradient( #5f6266ff 0% ${deviceStats.iosPercent}%, #8fe7d4ff ${deviceStats.iosPercent}% 100%)`,
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            inset: '35px',
            background: 'white',
            borderRadius: '50%'
          }}></div>

          {/* iOS Count Label */}
          {deviceStats.ios > 0 && (
            <div style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: `rotate(${(deviceStats.iosPercent / 2) * 3.6}deg) translate(0, -88px) rotate(-${(deviceStats.iosPercent / 2) * 3.6}deg)`,
              transformOrigin: '0 0',
              margin: '-10px 0 0 -15px',
              width: '30px',
              textAlign: 'center',
              fontSize: '11px',
              fontWeight: '800',
              color: '#f9fafcff',
              pointerEvents: 'none',
              zIndex: 2
            }}>
              {deviceStats.ios}
            </div>
          )}

          {/* Android Count Label */}
          {deviceStats.android > 0 && (
            <div style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: `rotate(${(deviceStats.iosPercent + (100 - deviceStats.iosPercent) / 2) * 3.6}deg) translate(0, -88px) rotate(-${(deviceStats.iosPercent + (100 - deviceStats.iosPercent) / 2) * 3.6}deg)`,
              transformOrigin: '0 0',
              margin: '-10px 0 0 -15px',
              width: '30px',
              textAlign: 'center',
              fontSize: '11px',
              fontWeight: '800',
              color: '#383a3aff',
              pointerEvents: 'none',
              zIndex: 2
            }}>
              {deviceStats.android}
            </div>
          )}
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '12px', fontSize: '14px' }}>
        <span style={{ color: '#5f6266ff', fontWeight: 600 }}>iOS {deviceStats.iosLabel}% </span> •
        <span style={{ color: '#8fe7d4ff', fontWeight: 600 }}>Android {deviceStats.androidLabel}%</span>
      </div>
    </div>
  );
});

export const AgeGenderDistributionChart = React.memo(({ ageGenderData }) => {
  return (
    <div className="chart-card" style={{
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      height: '425px'
    }}>
      <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, textAlign: 'center' }}>
        Age Distribution Gender wise
      </h3>
      <div style={{ padding: '0 8px' }}>
        {ageGenderData.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: i === ageGenderData.length - 1 ? '8px' : '12px' }}>
            <div style={{ width: '80px', fontSize: '13px', color: '#64748b', fontWeight: 500 }}>
              {item.label}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  height: '8px',
                  width: `${item.malePercent}%`,
                  minWidth: item.male > 0 ? '4px' : '0',
                  background: '#5d5fdfff',
                  borderRadius: '0 4px 4px 0',
                  transition: 'width 0.4s'
                }}></div>
                {item.male > 0 && (
                  <span style={{ fontSize: '11px', fontWeight: 600, color: '#5d5fdfff' }}>{item.male}</span>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  height: '8px',
                  width: `${item.femalePercent}%`,
                  minWidth: item.female > 0 ? '4px' : '0',
                  background: '#f155cfff',
                  borderRadius: '0 4px 4px 0',
                  transition: 'width 0.4s'
                }}></div>
                {item.female > 0 && (
                  <span style={{ fontSize: '11px', fontWeight: 600, color: '#f155cfff' }}>{item.female}</span>
                )}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  height: '8px',
                  width: `${item.othersPercent}%`,
                  minWidth: item.others > 0 ? '4px' : '0',
                  background: '#f59e0bff',
                  borderRadius: '0 4px 4px 0',
                  transition: 'width 0.4s'
                }}></div>
                {item.others > 0 && (
                  <span style={{ fontSize: '11px', fontWeight: 600, color: '#f59e0bff' }}>{item.others}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div style={{ textAlign: 'center', marginTop: '6px', fontSize: '13px', display: 'flex', justifyContent: 'center', gap: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ display: 'inline-block', width: '12px', height: '12px', background: '#5d5fdfff', borderRadius: '2px' }}></span>
          <span style={{ color: '#64748b' }}>Male</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ display: 'inline-block', width: '12px', height: '12px', background: '#f155cfff', borderRadius: '2px' }}></span>
          <span style={{ color: '#64748b' }}>Female</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ display: 'inline-block', width: '12px', height: '12px', background: '#f59e0bff', borderRadius: '2px' }}></span>
          <span style={{ color: '#64748b' }}>Others</span>
        </div>
      </div>
    </div>
  );
});

export const RegistrationTrendsChart = React.memo(({ trendChartData, trendView, setTrendView }) => {
  const maxVal = Math.max(...trendChartData.map(d => d.count), 5);
  const roundedMax = Math.ceil(maxVal / 10) * 10;
  const scaleValue = (val) => (val / roundedMax) * 15;

  const getY = (value) => {
    const v = Math.min(value, 15);
    if (v <= 4) return 200 - (v / 4) * 50;
    else if (v <= 8) return 150 - ((v - 4) / 4) * 40;
    else if (v <= 11) return 110 - ((v - 8) / 3) * 30;
    else return 80 - ((v - 11) / 4) * 40;
  };

  return (
    <div className="chart-card" style={{
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid #f1f5f9',
      height: '425px'
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', fontWeight: 600, textAlign: 'center' }}>
          Registration Trends
        </h3>
      </div>
      <div style={{
        display: 'flex',
        background: '#f1f5f9',
        padding: '4px',
        borderRadius: '8px',
        width: 'fit-content',
        margin: '0 auto 1px auto'
      }}>
        {['Monthly', 'Weekly', 'Daily'].map(view => (
          <button
            key={view}
            onClick={() => setTrendView(view)}
            style={{
              padding: '8px 20px',
              borderRadius: '6px',
              border: 'none',
              fontSize: '14px',
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              background: trendView === view ? '#4f46e5' : 'transparent',
              color: trendView === view ? 'white' : '#64748b',
              boxShadow: trendView === view ? '0 2px 4px rgba(79, 70, 229, 0.2)' : 'none'
            }}
          >
            {view}
          </button>
        ))}
      </div>
      <div style={{ height: '280px', width: '100%', position: 'relative', marginTop: '1px', paddingLeft: '30px', paddingBottom: '10px' }}>
        {trendChartData.length > 1 ? (
          <svg width="100%" height="100%" viewBox="0 0 500 250" preserveAspectRatio="none" style={{ overflow: 'visible' }}>
            {(() => {
              const steps = 4;
              const stepSize = roundedMax / steps;
              const yAxisValues = Array.from({ length: 5 }, (_, i) => i * stepSize);
              return yAxisValues.map((val, i) => {
                const yPos = getY(scaleValue(val));
                return (
                  <g key={i}>
                    <line x1="0" y1={yPos} x2="500" y2={yPos} stroke="#f1f5f9" strokeWidth="1" />
                    <text x="-10" y={yPos + 4} textAnchor="end" fontSize="10" fill="#94a3b8">
                      {Math.round(val)}
                    </text>
                  </g>
                );
              });
            })()}
            {(() => {
              const points = trendChartData.map((d, i) => {
                const x = (i / (trendChartData.length - 1)) * 500;
                const y = getY(scaleValue(d.count));
                return `${x},${y}`;
              }).join(' ');
              return (
                <>
                  <polyline fill="none" stroke="#4f46e5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" points={points} />
                  <polygon points={`${points} 500,200 0,200`} fill="url(#trendGradient)" style={{ opacity: 0.1 }} />
                  <defs>
                    <linearGradient id="trendGradient" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#4f46e5" />
                      <stop offset="100%" stopColor="#4f46e5" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                  {trendChartData.map((d, i) => {
                    const x = (i / (trendChartData.length - 1)) * 500;
                    const y = getY(scaleValue(d.count));
                    return (
                      <g key={i}>
                        <circle cx={x} cy={y} r="4" fill="white" stroke="#4f46e5" strokeWidth="2" />
                        <text x={x} y={y - 12} textAnchor="middle" fontSize="11" fontWeight="700" fill="#4f46e5">{d.count}</text>
                        <text 
                            x={x} 
                            y="225" 
                            textAnchor="end" 
                            fontSize="9" 
                            fill="#64748b"
                            transform={`rotate(-45, ${x}, 225)`}
                        >
                            {d.label}
                        </text>
                      </g>
                    );
                  })}
                </>
              );
            })()}
          </svg>
        ) : (
          <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>
            No trend data available for this view
          </div>
        )}
      </div>
    </div>
  );
});
